// extracted by mini-css-extract-plugin
export default {"heading2":"auxTitle-module--heading2--oWUOf","primary":"auxTitle-module--primary--EMAsC","secondary":"auxTitle-module--secondary--rv3hq","bold":"auxTitle-module--bold--TuG36"};